// extracted by mini-css-extract-plugin
export default {"SidebarContainer":"eXmSsnvQbQ7ANMt40LNF"};